export class MbDatatablesTemplate{
    public static HEADER_TEMPLATE = 'hdrTpl';
    public static TRANSLATE_TEMPLATE = 'translateTpl';
    public static PURE_TRANSLATE_TEMPLATE = 'pureTranslateTpl';
    public static DATETIME_TEMPLATE = 'datetimeTpl';
    public static DATE_TEMPLATE = 'dateTpl';
    public static ACTION_TEMPLATE = 'actionsTpl';
    public static SHOW_DETAILS_TEMPLATE = 'showDetailsTpl';
}
